import { useState, useEffect } from 'react';
import { useRoom } from '../../../contexts/RoomContext';
import { BACKEND_URL } from '../../../services/authService';

export default function IntroSettings() {
  const { currentRoom, refetchRoom } = useRoom();
  const [enabled, setEnabled] = useState(currentRoom?.introEnabled ?? true);
  const [interval, setInterval] = useState(currentRoom?.introIntervalMinutes ?? 30);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (currentRoom?.introEnabled !== undefined) {
      setEnabled(currentRoom.introEnabled);
    }
    if (currentRoom?.introIntervalMinutes !== undefined) {
      setInterval(currentRoom.introIntervalMinutes);
    }
  }, [currentRoom]);

  const handleEnabledChange = async () => {
    const newValue = !enabled;
    setEnabled(newValue);
    setLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/room/setIntroEnabled?introEnabled=${newValue}`, {
        method: 'POST',
        credentials: 'include'
      });
      if (!response.ok) throw new Error('Failed to update intro setting');
      await refetchRoom();
    } catch (e) {
      console.error('Error updating intro enabled:', e);
    } finally {
      setLoading(false);
    }
  };

  const handleIntervalChange = (e) => {
    setInterval(Number(e.target.value));
  };

  const handleIntervalBlur = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/room/setIntroIntervalMinutes?introIntervalMinutes=${interval}`, {
        method: 'POST',
        credentials: 'include'
      });
      if (!response.ok) throw new Error('Failed to update intro interval');
      await refetchRoom();
    } catch (e) {
      console.error('Error updating intro interval:', e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-white">Bot Introduction Settings</h3>
      <div className="p-4 rounded-lg bg-[#2E2E2E] border border-gray-700 space-y-4">
        <div className="flex items-center">
          <label className="flex-1 text-sm text-gray-300">Enable Bot Introduction</label>
          <button
            onClick={handleEnabledChange}
            disabled={loading}
            className={`px-3 py-1 rounded text-sm ${
              enabled ? 'bg-green-600 hover:bg-green-700' : 'bg-gray-600 hover:bg-gray-700'
            } text-white transition-colors disabled:opacity-50`}>
            {enabled ? 'Enabled' : 'Disabled'}
          </button>
        </div>
        <div>
          <label className="text-sm text-gray-300">Introduction Interval (minutes)</label>
          <input
            type="number"
            min="1"
            value={interval}
            onChange={handleIntervalChange}
            onBlur={handleIntervalBlur}
            disabled={loading}
            className="mt-1 w-24 bg-[#2A2A2A] border border-gray-600 rounded px-2 py-1 text-sm text-white" />
        </div>
      </div>
    </div>
  );
}
